// Resolve a product image path against the app's public base URL so images
// load correctly whether the app is served from the domain root (Vercel) or a
// sub-folder (the HostGator demo). Backend image_url values look like
// "/products/<slug>.jpg"; full http(s) URLs are returned unchanged.
export function imageSrc(url) {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  const base = process.env.PUBLIC_URL || "";
  return `${base}${url}`;
}
